import React from 'react';
import { Outlet } from 'react-router-dom';
import { Authlayout } from './Authlayout';

export const MainLayout = () => {
  const token = localStorage.getItem('idUserToken');
  return <>{token ? <Outlet /> : <Authlayout />}</>;
};
